import React from 'react';

import { Icon, Sheet, Text } from '../../../../components';
import { notesTone, type DataNote } from '../../quality/notices';
import { Pill, List, Item, NoteText } from './DataNotes.styles';

export type DataNotesProps = {
  /** The active notes, in the order `dataNotes` gives them. */
  notes: readonly DataNote[];
};

/** The sheet's list: each note in its order, with its `{{n}}` filled in. */
export const DataNotesList = ({ notes }: DataNotesProps): React.ReactElement => (
  <List>
    {notes.map((note) => (
      <Item key={note.id}>
        <NoteText text={note.text} placeholders={note.n === undefined ? undefined : { n: note.n }} tag="paragraph" />
      </Item>
    ))}
  </List>
);

/** The `Data notes (n)` button beside the report download, shown while a note is active; it opens the notes sheet. */
export const DataNotes = ({ notes }: DataNotesProps): React.ReactElement | null => {
  const [open, setOpen] = React.useState(false);
  if (notes.length === 0) return null;
  const tone = notesTone(notes);
  return (
    <>
      <Pill
        type="button"
        $warning={tone === 'warning'}
        data-tone={tone}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <Icon name={tone === 'warning' ? 'warning' : 'info'} size={18} />
        <Text text="Data notes ({{n}})" placeholders={{ n: notes.length }} tag="span" />
      </Pill>
      {open ? (
        <Sheet
          title="Data notes ({{n}})"
          titlePlaceholders={{ n: notes.length }}
          onClose={() => setOpen(false)}
          maxWidth="480px"
        >
          <DataNotesList notes={notes} />
        </Sheet>
      ) : null}
    </>
  );
};

export default DataNotes;
